module.exports = __webpack_public_path__ + "media/01.bc341dd6.mp3";